import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { useStrings } from '../../contexts/StringsContext';
import styles from './WarningModal.css';
import { TimeoutModalTypes } from '../../constants/timeoutModalTypes';
export var WarningModal = function (_a) {
    var type = _a.type, onClick = _a.onClick, _b = _a.startTimeInSeconds, startTimeInSeconds = _b === void 0 ? 0 : _b;
    var strings = useStrings();
    var buttonRef = useRef(null);
    var _c = useState(0), timeLeft = _c[0], setTimeLeft = _c[1];
    var _d = useState(0), readTimeLeft = _d[0], setReadTimeLeft = _d[1];
    useEffect(function () {
        var _a;
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        document.body.addEventListener('focus', handleFocus, true);
        // Cleanup
        return function () {
            document.body.removeEventListener('focus', handleFocus, true);
        };
    }, [type]);
    useEffect(function () {
        if (startTimeInSeconds > 0) {
            setTimeLeft(startTimeInSeconds);
            // Interval to update the time left
            var intervalId_1 = setInterval(function () {
                setTimeLeft(function (currentTime) {
                    var newTime = Math.max(0, currentTime - 1);
                    if (newTime < 10 || newTime % 10 === 0) {
                        setReadTimeLeft(newTime);
                    }
                    return newTime;
                });
            }, 1000);
            // Cleanup
            return function () {
                clearInterval(intervalId_1);
            };
        }
    }, [startTimeInSeconds]);
    function handleFocus(e) {
        var _a;
        if (e.target !== buttonRef.current) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
    // Format time left as MM:SS
    function formatTime(time) {
        var minutes = Math.floor(time / 60);
        var seconds = time % 60;
        var formattedTime = "".concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds);
        return formattedTime;
    }
    function formatReadTime(time) {
        var minutes = Math.floor(time / 60);
        var seconds = time % 60;
        // When remaining time is less than 10 seconds, only announce second to avoid screen reader choked.
        var formattedTime = "".concat(time < 10 ? '' : "".concat(minutes, ":")).concat(time > 10 && seconds < 10 ? '0' : '').concat(seconds);
        return formattedTime;
    }
    return (_jsx("div", { className: styles.modal, children: _jsx("div", { className: styles.dialog, children: _jsxs("div", { className: styles.content, children: [type === TimeoutModalTypes.WARNING && (_jsxs("div", { className: styles.modalBody, role: "alertdialog", "aria-labelledby": "warning-modal-header", children: [_jsx("h1", { className: styles.heading, id: "warning-modal-header", children: strings.warningHeader }), _jsx("div", { className: styles.body, children: strings.warningBody }), _jsx("div", { className: styles.countdown, children: formatTime(timeLeft) }), _jsx("div", { className: styles.btn, children: _jsx("button", { className: styles.button, onClick: onClick, ref: buttonRef, children: strings.warningButton }) }), _jsx("div", { id: "warning-modal-reading-zone", "aria-live": "assertive", role: "status", className: styles.readingZone, children: _jsx("span", { children: formatReadTime(readTimeLeft) }) })] })), type === TimeoutModalTypes.SESSION && (_jsxs("div", { className: styles.modalBody, role: "alertdialog", "aria-labelledby": "session-modal-header", children: [_jsx("h1", { className: styles.heading, id: "session-modal-header", children: strings.sessionHeader }), _jsx("div", { className: styles.body, children: strings.sessionBody }), _jsx("div", { className: styles.btn, children: _jsx("button", { className: styles.button, onClick: onClick, ref: buttonRef, children: strings.sessionButton }) })] }))] }) }) }));
};
export default WarningModal;
